module.exports = __webpack_public_path__ + "static/media/AggregatorCategory.de78daff.pdf";